import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { EntityCertificationsTab } from '@/app/(client)/my-styles/-components/EntityCertificationsTab';
import { entityCertificationsQueryOptions } from '@/app/(client)/my-styles/-hooks/useEntityCertificationsQuery';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { ensurePermissions } from '@/hooks/usePermissions';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications',
)({
  validateSearch: z.object({
    dialog: z.enum(['create-certification-manual']).optional().catch(undefined),
  }),
  beforeLoad: async ({ params }) => {
    // Matches the backend `styles:read` guard on the certifications feed for
    // this style; the tab is hidden in the tab bar too, but a deep-link would
    // otherwise render an empty page and fire a request the user cannot see.
    const { styles } = await ensurePermissions();
    if (!styles.canRead) {
      throw redirect({
        to: '/my-styles/$kind/$id/overview',
        params: { kind: params.kind, id: params.id },
      });
    }
  },
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      entityCertificationsQueryOptions(params.id, { page: 1, count: 50 }),
    ),
  component: CertificationsRoute,
});

function CertificationsRoute() {
  const { kind, id } = Route.useParams();
  const safeKind = isEntityKindPath(kind) ? kind : 'styles';
  return <EntityCertificationsTab kind={safeKind} entityId={id} />;
}
